module.exports = __webpack_public_path__ + "img/img7.a5a25885.svg";